/**
 * Dados iniciais dos agentes de IA (mock).
 * Estrutura preparada para API: knowledgeBase com id, type, name, size?, createdAt;
 * integrations com id, name, status.
 * Ponto de integração: substituir por fetch de GET /api/agents.
 */

export const INITIAL_AI_AGENTS = [
  {
    id: 'ai_qualifier',
    internalName: 'Agente de Vendas 01',
    publicName: 'Juliana Castro',
    teamId: 'sales',
    description: 'Especialista em qualificação de leads e agendamento.',
    prompt:
      'Aja como uma vendedora humana chamada Juliana. Seja cordial e tente entender a dor do cliente.',
    knowledgeBase: [
      {
        id: 'kb_qualifier_1',
        type: 'url',
        name: 'https://meusite.com/precos',
        url: 'https://meusite.com/precos',
        createdAt: '2024-01-15T10:00:00.000Z',
      },
      {
        id: 'kb_qualifier_2',
        type: 'file',
        name: 'catalogo_2024.pdf',
        size: 1024000,
        createdAt: '2024-01-16T14:00:00.000Z',
      },
    ],
    integrations: [
      { id: 'int_qualifier_1', name: 'Pipedrive (CRM)', status: 'active' },
    ],
  },
  {
    id: 'ai_support',
    internalName: 'Suporte Técnico N1',
    publicName: 'Ricardo Oliveira',
    teamId: 'support',
    description: 'Resolve dúvidas técnicas baseadas no FAQ.',
    prompt: 'Você é o Ricardo do suporte. Use uma linguagem simples e direta.',
    knowledgeBase: [
      {
        id: 'kb_support_1',
        type: 'url',
        name: 'https://suporte.empresa.com/faq',
        url: 'https://suporte.empresa.com/faq',
        createdAt: '2024-01-10T09:00:00.000Z',
      },
    ],
    integrations: [
      { id: 'int_support_1', name: 'Zendesk Sync', status: 'active' },
    ],
  },
];
